// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OpeningHourTimeResponse

export type OpeningHourTimeApiResponse = {
	start: string;
	end: string;
};

export type OpeningHourTime = {
	start: string;
	end: string;
};

export function hydrateOpeningHourTime(data: OpeningHourTimeApiResponse): OpeningHourTime {
	return { ...data };
}